import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [actuel, setActuel] = useState("");
  const [nouveau, setNouveau] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nouveau !== confirm) return toast.error("Les deux nouveaux mots de passe ne correspondent pas.");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-password", { mot_de_passe_actuel: actuel, nouveau_mot_de_passe: nouveau });
      toast.success(data.message);
      setActuel(""); setNouveau(""); setConfirm("");
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-dd-blue"><KeyRound size={18} /> Changer mon mot de passe</DialogTitle>
          <DialogDescription>8 caractères minimum. Vos autres appareils seront déconnectés.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="pw-actuel">Mot de passe actuel</Label>
            <Input id="pw-actuel" type="password" required value={actuel} onChange={(e) => setActuel(e.target.value)} className="mt-1 h-11" autoComplete="current-password" data-testid="pw-actuel" />
          </div>
          <div>
            <Label htmlFor="pw-nouveau">Nouveau mot de passe</Label>
            <Input id="pw-nouveau" type="password" required minLength={8} value={nouveau} onChange={(e) => setNouveau(e.target.value)} className="mt-1 h-11" autoComplete="new-password" data-testid="pw-nouveau" />
          </div>
          <div>
            <Label htmlFor="pw-confirm">Confirmer le nouveau mot de passe</Label>
            <Input id="pw-confirm" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 h-11" autoComplete="new-password" data-testid="pw-confirm" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-dd-blue hover:bg-dd-night text-white" data-testid="pw-submit">
            {loading ? "Enregistrement…" : "Modifier le mot de passe"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
